"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JwtPayload = void 0;

var LwtClaim_1 = require("./LwtClaim");

var JwtPayload =
/** @class */
function () {
  function JwtPayload() {}

  JwtPayload.prototype.populate = function (parsedClaims) {
    this.lwt = new LwtClaim_1.LwtClaim();
    this.lwt.populate(parsedClaims['http://lwt']);
    delete parsedClaims['http://lwt'];
    Object.assign(this, parsedClaims);
  };

  JwtPayload.prototype.getIssuer = function () {
    return this.iss;
  };

  JwtPayload.prototype.getSubject = function () {
    return this.sub;
  };

  JwtPayload.prototype.getAudience = function () {
    return this.aud;
  };

  JwtPayload.prototype.getFirstName = function () {
    return this.given_name;
  };

  JwtPayload.prototype.getLastName = function () {
    return this.family_name;
  };

  JwtPayload.prototype.getNickname = function () {
    return this.nickname;
  };

  JwtPayload.prototype.getName = function () {
    return this.name;
  };

  JwtPayload.prototype.getEmail = function () {
    return this.email;
  };

  JwtPayload.prototype.getIssuedAtTime = function () {
    return this.iat;
  };

  JwtPayload.prototype.getExpirationTime = function () {
    return this.exp;
  };

  JwtPayload.prototype.getPicture = function () {
    return this.picture;
  };

  JwtPayload.prototype.getLwtClaim = function () {
    return this.lwt;
  };

  JwtPayload.prototype.getEmailVerified = function () {
    return this.email_verified;
  };

  return JwtPayload;
}();

exports.JwtPayload = JwtPayload;